import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./component/App";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './Fontstyles.css';
import './index.css';
import './responsive.css';
import { LoginProvider } from './context/LoginContext';
import { BrowserRouter } from 'react-router-dom'; // Add this import

const ignoredResizeObserverErrors = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded'
];

window.addEventListener('error', (event) => {
  if (ignoredResizeObserverErrors.includes(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename="/lms">
      <LoginProvider>
        <App />
      </LoginProvider>
    </BrowserRouter>
);
